import { render } from "./recoverPassword.vue?vue&type=template&id=e000f776&scoped=true&ts=true"
import script from "./recoverPassword.vue?vue&type=script&lang=ts"
export * from "./recoverPassword.vue?vue&type=script&lang=ts"

import "./recoverPassword.vue?vue&type=style&index=0&id=e000f776&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e000f776"]])

export default __exports__